(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["block-of-product-template"]) return;
  try {
    
  // NOTE: All subscription functionality has been moved to custom.js file
  // This includes:
  // - Quarterly date calculation (calculateNextQuarterStartDate)
  // - Date formatting (formatSubscriptionDate)
  // - Subscription start date updates (updateSubscriptionStartDate)
  // - Bundle add to cart functionality
  // - Bundle removal functionality
  // - Cart drawer integration

  // Only keeping the essential date calculation functions needed for the subscription start date display
  document.addEventListener('DOMContentLoaded', function () {
    // Function to calculate next quarter start date
    function calculateNextQuarterStartDate() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); // 0-11 (Jan-Dec)
      const currentYear = currentDate.getFullYear();

      let quarterStartMonth;
      let quarterStartYear;

      // Determine shipping quarter based on order month
      if (currentMonth === 11 || currentMonth === 0 || currentMonth === 1) {
        // Dec, Jan, Feb
        quarterStartMonth = 2; // March
        quarterStartYear = currentMonth === 11 ? currentYear + 1 : currentYear;
      } else if (currentMonth >= 2 && currentMonth <= 4) {
        // Mar, Apr, May
        quarterStartMonth = 5; // June
        quarterStartYear = currentYear;
      } else if (currentMonth >= 5 && currentMonth <= 7) {
        // Jun, Jul, Aug
        quarterStartMonth = 8; // September
        quarterStartYear = currentYear;
      } else {
        // Sep, Oct, Nov
        quarterStartMonth = 11; // December
        quarterStartYear = currentYear;
      }

      return {
        month: quarterStartMonth,
        year: quarterStartYear,
        monthName: new Date(quarterStartYear, quarterStartMonth).toLocaleDateString('en-US', { month: 'long' }),
      };
    }

    // Function to format date with billing day
    function formatSubscriptionDate(billingDay) {
      const quarterInfo = calculateNextQuarterStartDate();
      const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];

      return `${billingDay} ${monthNames[quarterInfo.month]} ${quarterInfo.year}`;
    }

    // Update subscription start date input
    function updateSubscriptionStartDate() {
      const button = document.querySelector('.subscription-add-to-cart');
      if (button) {
        const billingDay = button.dataset.billingDay;
        if (billingDay) {
          const startDate = formatSubscriptionDate(parseInt(billingDay));
          const startDateInput = document.getElementById('subscription-start-date');
          const cartDateInput = document.getElementById('cart-delivery-date');
          if (startDateInput) {
            startDateInput.value = startDate;
          }
          if (cartDateInput) {
            cartDateInput.value = startDate;
          }
        }
      }
    }

    // Initialize subscription start date on page load
    updateSubscriptionStartDate();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bom-product-template"]) return;
  try {
    
  // NOTE: All subscription functionality has been moved to custom.js file
  // This includes:
  // - Quarterly date calculation (calculateNextQuarterStartDate)
  // - Date formatting (formatSubscriptionDate)
  // - Subscription start date updates (updateSubscriptionStartDate)
  // - Bundle add to cart functionality
  // - Bundle removal functionality
  // - Cart drawer integration

  // Only keeping the essential date calculation functions needed for the subscription start date display
  document.addEventListener('DOMContentLoaded', function () {
    // Function to calculate next quarter start date
    function calculateNextQuarterStartDate() {
      const currentDate = new Date();
      const currentMonth = currentDate.getMonth(); // 0-11 (Jan-Dec)
      const currentYear = currentDate.getFullYear();

      let quarterStartMonth;
      let quarterStartYear;

      // Determine shipping quarter based on order month
      if (currentMonth === 11 || currentMonth === 0 || currentMonth === 1) {
        // Dec, Jan, Feb
        quarterStartMonth = 2; // March
        quarterStartYear = currentMonth === 11 ? currentYear + 1 : currentYear;
      } else if (currentMonth >= 2 && currentMonth <= 4) {
        // Mar, Apr, May
        quarterStartMonth = 5; // June
        quarterStartYear = currentYear;
      } else if (currentMonth >= 5 && currentMonth <= 7) {
        // Jun, Jul, Aug
        quarterStartMonth = 8; // September
        quarterStartYear = currentYear;
      } else {
        // Sep, Oct, Nov
        quarterStartMonth = 11; // December
        quarterStartYear = currentYear;
      }

      return {
        month: quarterStartMonth,
        year: quarterStartYear,
        monthName: new Date(quarterStartYear, quarterStartMonth).toLocaleDateString('en-US', { month: 'long' }),
      };
    }

    // Function to format date with billing day
    function formatSubscriptionDate(billingDay) {
      const quarterInfo = calculateNextQuarterStartDate();
      const monthNames = [
        'January',
        'February',
        'March',
        'April',
        'May',
        'June',
        'July',
        'August',
        'September',
        'October',
        'November',
        'December',
      ];

      return `${billingDay} ${monthNames[quarterInfo.month]} ${quarterInfo.year}`;
    }

    // Update subscription start date input
    function updateSubscriptionStartDate() {
      const button = document.querySelector('.subscription-add-to-cart');
      if (button) {
        const billingDay = button.dataset.billingDay;
        if (billingDay) {
          const startDate = formatSubscriptionDate(parseInt(billingDay));
          const startDateInput = document.getElementById('subscription-start-date');
          const cartDateInput = document.getElementById('cart-delivery-date');
          if (startDateInput) {
            startDateInput.value = startDate;
          }
          if (cartDateInput) {
            cartDateInput.value = startDate;
          }
        }
      }
    }

    // Initialize subscription start date on page load
    updateSubscriptionStartDate();
  });

  } catch(e) { console.error(e); }
})();
})();
